import { Heading, Flex, Text } from "@chakra-ui/react";

export default function PageHeaderStructure({ title, subtitle, children }) {
  return (
    <Flex
      bg="white"
      align="center"
      justify="space-between"
      gap="16px"
      borderRadius="12px"
      p="32px"
    >
      <Flex flexDir="column" gap="16px">
        <Heading fontSize="24px">{title}</Heading>
        {subtitle && (
          <Text
            fontSize={{ lg: "sm", "2xl": "15px" }}
            lineHeight={{lg:"22px", "2xl": '26px'}}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
      </Flex>
      {children}
    </Flex>
  );
}
